const shimmerBone =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] animate-pulse";

const inputShell =
  "bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk rounded-lg";

const FILTER_SHIMMER_ROW_COUNT = 6;

const VALUE_INNER_WIDTH_CLASSES = [
  "w-[72%]",
  "w-[80%]",
  "w-[68%]",
  "w-[76%]",
  "w-[84%]",
  "w-[70%]",
];

const FieldPillShimmer = () => (
  <div
    className={`h-[32px] w-[150px] min-w-[150px] max-w-[150px] shrink-0 ${inputShell} flex items-center gap-1.5 px-2`}
  >
    <div className={`w-3.5 h-3.5 rounded shrink-0 ${shimmerBone}`} />
    <div className={`h-3 flex-1 min-w-0 rounded ${shimmerBone}`} />
    <div className={`w-3.5 h-3.5 rounded shrink-0 ${shimmerBone}`} />
  </div>
);

const OperatorPillShimmer = () => (
  <div
    className={`h-[32px] w-[90px] shrink-0 ${inputShell} flex items-center justify-between px-2 gap-1`}
  >
    <div className={`h-3 flex-1 rounded max-w-[52px] ${shimmerBone}`} />
    <div className={`w-3.5 h-3.5 rounded shrink-0 ${shimmerBone}`} />
  </div>
);

const ValuePillShimmer = ({ valueInnerWidthClass }: { valueInnerWidthClass: string }) => (
  <div
    className={`flex-1 min-w-0 h-[32px] ${inputShell} flex items-center px-2`}
  >
    <div className={`h-3.5 rounded ${valueInnerWidthClass} max-w-full ${shimmerBone}`} />
  </div>
);

const FilterRowShimmer = ({ valueInnerWidthClass }: { valueInnerWidthClass: string }) => (
  <div className="flex items-center gap-2 min-h-[48px] w-full min-w-0">
    <FieldPillShimmer />
    <OperatorPillShimmer />
    <ValuePillShimmer valueInnerWidthClass={valueInnerWidthClass} />
    <div className="w-5 shrink-0 flex items-center justify-center self-stretch">
      <div className={`w-3.5 h-3.5 rounded-sm ${shimmerBone}`} />
    </div>
  </div>
);

const filterRowGlobalBlockShell =
  "rounded-lg p-2 bg-hover-effect dark:bg-hover-effect-dk flex items-center w-full min-w-0";

const AndConnectorShimmer = () => (
  <div className="w-[70px] shrink-0 flex justify-center pt-3">
    <div className={`h-7 w-[44px] shrink-0 rounded-md ${shimmerBone}`} />
  </div>
);

export const CreateViewFiltersLoadingShimmer = () => {
  return (
    <div className="flex flex-col h-full bg-pure-white dark:bg-pure-white-dk overflow-hidden rounded-l-[8px] min-h-[200px]">
      <div className="border-b border-border-gray dark:border-border-gray-dk flex items-center justify-between px-3 h-[50px] shrink-0 rounded-tl-[8px]">
        <span className="text-base font-semibold text-verba-indigo dark:text-verba-indigo-dk">
          Filters
        </span>
        <div className="flex items-center gap-4">
          <div className={`h-[26px] w-[72px] rounded-md ${shimmerBone}`} />
          <div
            className={`w-[18px] h-[18px] rounded-full shrink-0 ${shimmerBone}`}
          />
        </div>
      </div>

      <div className="relative flex-1 overflow-y-auto min-h-0">
        <div className="flex flex-col gap-3 px-4 py-6">
          {Array.from({ length: FILTER_SHIMMER_ROW_COUNT }).map((_, index) => {
            const valueWidthClass = VALUE_INNER_WIDTH_CLASSES[index] ?? "w-[75%]";
            const globalBlockMinHeight =
              index % 2 === 0 ? "min-h-[20dvh]" : "min-h-[10dvh]";
            const row = (
              <FilterRowShimmer valueInnerWidthClass={valueWidthClass} />
            );

            if (index === 0) {
              return (
                <div key={index} className="pl-[70px]">
                  <div
                    className={`${filterRowGlobalBlockShell} ${globalBlockMinHeight}`}
                  >
                    {row}
                  </div>
                </div>
              );
            }

            return (
              <div key={index} className="flex items-start">
                <AndConnectorShimmer />
                <div
                  className={`flex-1 min-w-0 ${filterRowGlobalBlockShell} ${globalBlockMinHeight}`}
                >
                  {row}
                </div>
              </div>
            );
          })}

          <div className="pl-[70px] pt-3">
            <div className={`h-[32px] w-[168px] rounded-lg ${shimmerBone}`} />
          </div>
        </div>
      </div>

      <div className="px-[18px] py-[18px] backdrop-blur-[20px] shrink-0 border-t border-border-gray dark:border-border-gray-dk rounded-bl-[8px]">
        <div className="flex items-center justify-between">
          <div className={`h-[26px] w-[100px] rounded-md ${shimmerBone}`} />
          <div className={`h-[26px] w-[124px] rounded-md ${shimmerBone}`} />
        </div>
      </div>
    </div>
  );
};
